module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_vm._l((_vm.params.per_page), function(item, index) {
    return (_vm.isLoading === true) ? _c('mu-list-item', {
      key: 'params-' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.avatar,
        "color": "white",
        "backgroundColor": "white"
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.isLoading === false && _vm.hasItems) ? _c('mu-list', _vm._l((_vm.items), function(item, itemIndex) {
    return _c('mu-list-item', {
      key: 'question-item-' + itemIndex,
      staticClass: "userQuestion",
      attrs: {
        "to": {
          path: ("/questions/thread/" + (item.question_id))
        }
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('p', {
      staticClass: "question-title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(item.question))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "question-by"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('message.discussionAskedBySuffix')) + "\n          "), _c('router-link', {
      attrs: {
        "to": {
          path: ("/profile/" + (item.url))
        }
      },
      domProps: {
        "textContent": _vm._s(item.display_name)
      }
    })], 1)]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.profile_large
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.fromNow(item.timestamp))
      }
    })])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasItems) ? _c('mu-card-text', [_vm._v(_vm._s(_vm.$t('message.labelNo')) + " " + _vm._s(_vm.type === 'MY_QUESTIONS' ? _vm.$t('message.labelQuestionsAsked').toLowerCase() : _vm.$t('message.labelQuestionsAnswered').toLowerCase()))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db9c7bd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/UserQuestions/UserQuestions.vue
// module id = 3741
// module chunks = 1